var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadionUnchecked = function SvgRadionUnchecked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.75,
    strokeWidth: 1.4,
    d: "M13.3 8A5.3 5.3 0 1 1 2.7 8a5.3 5.3 0 0 1 10.6 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadionUnchecked);
export { ForwardRef as ReactComponent };